const classOptions = [
  'yellow',
  'mint_100',
  'green',
  'purple_100',
  'teal_100',
  'aqua',
  'brown_100',
  'red',
  'sky',
  'purple',
  'lime',
  'blue_100',
  'pink_600',
  'turquoise',
  'red_200',
];
const classSize = classOptions.length;

const generateColor = (charCode: number) => {
  const classIndex = charCode % classSize;
  const color = classOptions[classIndex];
  return color;
};

export { generateColor };
